import * as React from "react";
import { TypedFieldProp } from "react-typed-form";
import styled from "styled-components";

import SELECT_ARROW from "../../../img/form/select-arrow.svg";
import { Color } from "../../constants/legacy";
import FieldText from "./FieldText";

type Choice = {
  value: string;
  label: string;
};

type Props = {
  field: TypedFieldProp<string | null>;
  choices: Choice[];
  label?: string;
  required?: boolean;
  /**
   * Useful if on a white background
   */
  bordered?: boolean;
};

export default function FieldSelect({ choices, ...rest }: Props) {
  const { field, bordered } = rest;
  return (
    <FieldText
      {...rest}
      innerElement={
        <>
          <StyledSelect
            value={field.value || ""}
            onChange={(ev) => field.handleValueChange(ev.target.value)}
            disabled={field.isLoading}
            $bordered={bordered || false}
          >
            <option value={undefined} />
            {choices.map((choice) => (
              <option key={choice.value} value={choice.value}>
                {choice.label}
              </option>
            ))}
          </StyledSelect>
          <StyledArrow src={SELECT_ARROW} />
        </>
      }
    />
  );
}

const StyledSelect = styled("select")<{ $bordered: boolean }>`
  outline: 0;
  box-sizing: border-box;
  width: 100%;
  background-color: transparent;
  border: 0;
  border-bottom: 1px ${(p) => (p.$bordered ? "#ddd" : "transparent")} solid;
  height: 48px;
  line-height: 48px;
  margin-top: 6px;
  padding: 0 20px;
  transition: box-shadow 0.35s;
  -webkit-appearance: none;

  &:focus {
    box-shadow: 0 2px 0 ${Color.orange};
  }

  &:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }
`;

const StyledArrow = styled.img`
  position: absolute;
  right: 20px;
  top: 25px;
`;
